export default __webpack_public_path__ + "static/media/plates.b97635f7.jpg";